import { useEffect, useRef } from "react";

/** Periodically re-run `onPoll` while `active`, and when the tab/window regains focus. */
export function usePollWhile(
    active: boolean,
    onPoll: () => void | Promise<void>,
    intervalMs = 12_000,
) {
    const onPollRef = useRef(onPoll);
    onPollRef.current = onPoll;

    useEffect(() => {
        if (!active) return;

        const run = () => {
            void onPollRef.current();
        };

        run();
        const id = setInterval(run, intervalMs);
        const onVisible = () => {
            if (document.visibilityState === "visible") run();
        };

        window.addEventListener("focus", run);
        document.addEventListener("visibilitychange", onVisible);

        return () => {
            clearInterval(id);
            window.removeEventListener("focus", run);
            document.removeEventListener("visibilitychange", onVisible);
        };
    }, [active, intervalMs]);
}
